module.exports = __webpack_public_path__ + "img/icon-rycx.a945c2f8.png";